const Switch = (($) => {

    const NAME = 'switch';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        onText: 'ON',
        offText: 'OFF',
        onColor: 'primary',
        offColor: 'default',
        size: null
    };
    const Selector = {
        SWITCH: `.js-${NAME}`
    }

    class Switch {
        constructor(element, config) {
            this._config = config;
            this._element = element;
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }


        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Switch(this, config);
                    $this.data(DATA_KEY, data).bootstrapSwitch(config);
                }
            });
        }
    }

    $(() => Switch._jQueryInterface.call($(Selector.SWITCH)));
    $(document).ajaxStop(() => Switch._jQueryInterface.call($(Selector.SWITCH)));

    $.fn[NAME] = Switch._jQueryInterface;
    $.fn[NAME].Constructor = Switch;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Switch._jQueryInterface;
    }

    return Switch;
})(jQuery);